import { WDD } from '../core/wdd.js';

export function buyButton() {
    const buttons = WDD.el.querySelectorAll(".jsBuy");

    buttons.forEach(button => {
        if (button.dataset.basketBound === "true") return;
        button.dataset.basketBound = "true";

        button.addEventListener("click", async event => {
            event.preventDefault();
            if (button.disabled || button.classList.contains("bp-button--adding") || button.classList.contains("bp-button--inBasket")) return;

            const productId = Number(button.dataset.oid);

            if (!Number.isInteger(productId) || productId <= 0) {
                console.error(new Error("Product ID not found in the button data-oid attribute."));
                return;
            }

            if (!button.dataset.text || !button.dataset.inBasket) {
                console.error(new Error("Basket button text data attributes are missing."));
                return;
            }

            button.classList.add("bp-button--adding");
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
            button.setAttribute("aria-label", button.dataset.text);

            const payload = {
                Items: [{
                    CommodityId: productId,
                    Count: 1
                }]
            };

            if (button.dataset.voucher) payload.VoucherCode = button.dataset.voucher;

            try {
                const response = await fetch("/api/basket/v1/items", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error(`Basket request failed with HTTP ${response.status}.`);
                }

                button.classList.remove("bp-button--adding");
                button.classList.add("bp-button--inBasket");
                button.setAttribute("aria-label", button.dataset.inBasket);
            } catch (error) {
                console.error("Unable to add the product to the basket:", error);
                button.disabled = false;
                button.setAttribute("aria-label", button.dataset.text);
            } finally {
                button.classList.remove("bp-button--adding");
                button.disabled = button.classList.contains("bp-button--inBasket");
                button.setAttribute("aria-busy", "false");
            }
        });
    });
}
